import Button from '@mui/material/Button'
import { IconButton } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colorTokens } from '@/apps/legacy/shared/styles/colorTokens'

export const CustomButton = styled(Button)(() => ({
  '&:hover': {
    backgroundColor: colorTokens.action.primaryBgHover,
  },
  // より濃い色を使用して可視性を向上
  color: colorTokens.blue[600],
  // アウトラインの場合はボーダーも強調
  '&.MuiButton-outlined': {
    borderColor: colorTokens.blue[600],
    borderWidth: '1.5px',
  },
}))

export const CustomIconButton = styled(IconButton)(() => ({
  color: colorTokens.blue[600],
  '&:hover': {
    backgroundColor: colorTokens.action.primaryBgHover,
  },
}))

// 戻るボタン用のスタイル
export const BackButton = styled(Button)(() => ({
  color: colorTokens.blue[600],
  borderWidth: '1.5px',
  borderColor: colorTokens.blue[600],
  '&:hover': {
    backgroundColor: colorTokens.action.primaryBgHover,
    borderColor: colorTokens.blue[600],
  },
}))

// 編集ボタン用のスタイル
export const EditButton = styled(Button)(() => ({
  color: colorTokens.blue[600],
  borderWidth: '1.5px',
  borderColor: colorTokens.blue[600],
  '&:hover': {
    backgroundColor: colorTokens.action.primaryBgHover,
    borderColor: colorTokens.blue[600],
  },
}))

// アクションボタン用のスタイル（新規追加など）
export const ActionButton = styled(Button)(() => ({
  color: colorTokens.background.paper,
  backgroundColor: colorTokens.blue[600],
  '&:hover': {
    backgroundColor: colorTokens.blue[700],
  },
}))

// キャンセルボタン用のスタイル
export const CancelButton = styled(Button)(() => ({
  color: colorTokens.text.secondary,
  borderWidth: '1.5px',
  borderColor: colorTokens.border.medium,
  '&:hover': {
    backgroundColor: colorTokens.action.secondaryBgHover,
    borderColor: colorTokens.grey[700],
  },
  // より目立つスタイル
  backgroundColor: colorTokens.background.paper,
}))

// タブスタイル強化
export const StyledTab = styled('div')(() => ({
  '&.Mui-selected': {
    color: colorTokens.blue[700],
    fontWeight: 'bold',
    backgroundColor: colorTokens.action.primaryBgLight,
  },
}))

// 選択件数表示用のスタイル
export const SelectionCount = styled('div')(() => ({
  color: colorTokens.blue[700],
  fontWeight: 'bold',
  padding: '8px 16px',
  borderRadius: '4px',
  border: `1.5px solid ${colorTokens.blue[700]}`,
  backgroundColor: colorTokens.action.primaryBgLight,
  display: 'inline-block',
}))
